import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

//import AmpFestLogo from "./assets/amp_fest.png";
import { useLocation } from "react-router-dom";
import {
  MONTH,
  START_DAY_OF_FESTIVAL,
  END_DAY_OF_FESTIVAL,
  YEAR,
} from "./constants/festivalDates";

const Header = () => {
  const [opacity, setOpacity] = useState(1);
  const [isHomePage, setIsHomePage] = useState(true);

  const location = useLocation();

  useEffect(() => {
    setIsHomePage(location.pathname === "/");
  }, [location]);

  const listenScrollEvent = (e: any) => {
    const startDisappearScrollY = 50;
    const disappearAtScrollY = 500;

    if (window.scrollY >= disappearAtScrollY) {
      setOpacity(0);
      return;
    }

    if (window.scrollY >= startDisappearScrollY) {
      const offset = window.scrollY - startDisappearScrollY;
      const opacityPercent = offset / 200;
      setOpacity(1 - opacityPercent + 0.1);
    } else {
      setOpacity(1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
  }, []);

  return (
    <Box
      sx={[
        {
          width: "100vw",
          marginBottom: "58px",
        },
        isHomePage && {
          height: "150px",
          // height: "calc(100vh - 180px)", // @ james if you get a logo put this back and remove the 200px and adjust as needed
        },
      ]}
    >
      {/* LOGO PLACEHOLDER */}
      {/* <Grid sx={{ textAlign: "center", opacity }} item xs={12}>
        <Box
          component="img"
          sx={[
            {
              // width: { xs: "100vw", sm: "100vw", md: 500, lg: 700 },
              // maxWidth: { xs: "100vw", sm: "100vw" },
              width: "auto",
              maxHeight: 500,
            },
            {
              maxHeight: { xs: 340 },
            },
          ]}
          alt="Amplitude Festival Logo"
          src={AmpFestLogo}
        />
      </Grid> */}
      <Grid
        container
        sx={{ textAlign: "center", opacity }}
        alignContent="baseline"
      >
        <Grid item xs={12}>
          <Typography
            sx={[
              {
                textTransform: "uppercase",
                letterSpacing: "2px",
                fontSize: 44,
                color: "yellow.main",
                fontWeight: 700,
              },
              { fontSize: { xs: 30 } },
            ]}
          >
            {MONTH} {START_DAY_OF_FESTIVAL}-{END_DAY_OF_FESTIVAL}, {YEAR}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
